"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookingEdit = bookingEdit;
exports.bookingPage = bookingPage;
exports.bookingSave = bookingSave;
exports.getBookingDetail = getBookingDetail;
exports.toggleEnable = toggleEnable;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var querestUrl = '/xyGoodsActivityBooking';

// 预定信息信息
function bookingSave(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'post',
    data: data
  });
}
// 预定信息编辑
function bookingEdit(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'put',
    data: data
  });
}

// 获取预定信息详情
function getBookingDetail(id) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/' + id,
    method: 'get'
  });
}

// 预定信息分页查询
function bookingPage(query) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/page',
    method: 'get',
    params: query
  });
}

// 快捷切换活动启用状态
function toggleEnable(fnId, markForEnable) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/toggleEnable',
    method: 'put',
    params: {
      fnId: fnId,
      markForEnable: markForEnable
    }
  });
}